export const isColorString = (color: string): boolean => {
    return (
        /^#([0-9A-F]{3}){1,2}$/i.test(color) ||
        /^rgb\((\d{1,3}%?,\s*){2}\d{1,3}%?\)$/i.test(color) ||
        /^hsl\(\d{1,3},\s*\d{1,3}%,\s*\d{1,3}%\)$/i.test(color)
    );
};
